import React, { useEffect, useState } from "react";
import "./ProductSinglePage.scss";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAsyncProductSingle,
  getProductSingle,
} from "../../store/productSlice";
import { STATUS } from "../../utils/status";
import Loader from "../../components/Loader/Loader";
import { formatPrice } from "../../utils/helpers";
import {
  addToCartAsync,
  getCartMessageStatus,
  setCartMessageOff,
  setCartMessageOn,
} from "../../store/cartSlice";
import {
  addTofavorite,
  getfavoriteMessageStatus,
  setfavoriteMessageOff,
  setfavoriteMessageOn,
} from "../../store/favoriteSlice";
import CartMessage from "../../components/CartMessage/CartMessage";
import FavoriteMessage from "../../components/FavoriteMessage/FavoriteMessage";
import Footer1 from "../../components/Footer/Footer1";
import {
  fetchAsyncVendorProducts,
} from "../../store/vendorSlice";
import { getCategorierProductById } from "../../store/categorySlice"; // Sélecteur personnalisé
import { IMAGE_URL1 } from "../../utils/apiURL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectUser } from "../../store/authSlice"; // Corriger le chemin si nécessaire

const ProductSingleCategoryPages = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const product = useSelector((state) => getCategorierProductById(state, id)); // Nouveau sélecteur pour un produit par ID
  const productSingleStatus = useSelector(getProductSingle); // Vérifie directement le produit
  const cartMessageStatus = useSelector(getCartMessageStatus);
  const favoriteMessageStatus = useSelector(getfavoriteMessageStatus);
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState("");
  const user = useSelector(selectUser);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!product) {
      dispatch(fetchAsyncProductSingle(id)); // Fetch si le produit n’est pas en cache
    }
  }, [id, product, dispatch]);


  console.log(token)

  useEffect(() => {
    if (product) {
      dispatch(fetchAsyncVendorProducts(product.vendor_id)); // Fetch les produits du vendeur
    }
  }, [product, dispatch]);

  useEffect(() => {
    if (cartMessageStatus) {
      const timer = setTimeout(() => dispatch(setCartMessageOff()), 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessageStatus, dispatch]);

  useEffect(() => {
    if (favoriteMessageStatus) {
      const timer = setTimeout(() => dispatch(setfavoriteMessageOff()), 2000);
      return () => clearTimeout(timer);
    }
  }, [favoriteMessageStatus, dispatch]);

  useEffect(() => {
    if (product?.product_images1) {
      setSelectedImage(product.product_images1);
    }
  }, [product]);

  if (productSingleStatus === STATUS.LOADING) {
    return <Loader />;
  }

  const increaseQty = () =>
    setQuantity((prev) => Math.min(prev + 1, product?.stock));
  const decreaseQty = () => setQuantity((prev) => Math.max(prev - 1, 1));

  const addToCartHandler = (product_id, quantity) => {
    if (!user) {
      toast.error("You must be logged in to add products to the cart.");
      return;
    }
    dispatch(addToCartAsync({ product_id, quantity, token }))
      .unwrap()
      .then(() => {
        toast.success("Product Added Successfully!");
        dispatch(setCartMessageOn(true));
      })
      .catch(() => toast.error("Error adding to cart."));
  };

  const addToFavoriteHandler = (product) => {
    const discountedPrice =
      product.price - product.price * (product.discountPercentage / 100);
    dispatch(addTofavorite({ ...product, quantity, discountedPrice }));
    dispatch(setfavoriteMessageOn(true));
  };

  const handleThumbnailClick = (image) => setSelectedImage(image);

  if (productSingleStatus === STATUS.LOADING) return <Loader />;

  return (
    <main className="py-5 bg-whitesmoke">
      <ToastContainer className="custom-toast" />
      <div className="product-single container">
        <div className="product-single-content bg-white grid">
          <div className="product-single-l">
            <div className="product-img">
              <img
                src={selectedImage ? IMAGE_URL1 + selectedImage : ""}
                alt="Product"
                className="img-cover"
              />
              <div className="product-img-thumbs flex">
                {["product_images1", "product_images2", "product_images3"].map(
                  (imgKey) =>
                    product?.[imgKey] ? (
                      <div
                        key={imgKey}
                        className="thumb-item"
                        onClick={() => handleThumbnailClick(product[imgKey])}
                      >
                        <img
                          src={IMAGE_URL1 + product[imgKey]}
                          alt="Thumbnail"
                          className="img-cover"
                        />
                      </div>
                    ) : null
                )}
              </div>
            </div>
          </div>
          <div className="product-single-r">
            <div className="product-details font-manrope">
              <div className="title fs-20 fw-5">{product?.product_name}</div>

              <div className="price">
                <div className="flex align-center my-1">
                  <div className="new-price fw-5 font-poppins fs-24 text-orange">
                    {formatPrice(product?.price)}
                  </div>
                </div>
              </div>

              <div className="qty flex align-center my-4">
                <div className="qty-text">Quantity:</div>
                <div className="qty-change flex align-center mx-3">
                  <button
                    type="button"
                    className="qty-decrease flex align-center justify-center"
                    onClick={decreaseQty}
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  <div className="qty-value flex align-center justify-center">
                    {quantity}
                  </div>
                  <button
                    type="button"
                    className="qty-increase flex align-center justify-center"
                    onClick={increaseQty}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                {product?.stock < 1 && (
                  <div className="qty-error text-uppercase bg-danger text-white fs-12 ls-1 mx-2 fw-5">
                    out of stock
                  </div>
                )}
              </div>
              <div className="info flex align-center flex-wrap fs-14">
                <div className="brand">
                  <span className="text-orange fw-5">Category:</span>
                  <span className="mx-1 text-capitalize">
                    {product?.categorie_name}
                  </span>
                </div>
                | &nbsp;
                <div className="brand">
                  <span className="text-orange fw-5">Remaining stock:</span>
                  <span className="mx-1 text-capitalize">
                    {product?.stock}
                  </span>
                </div>
              </div>
              <div className="btns">
                <button
                  type="button"
                  className="add-to-cart-btn btn"
                  onClick={() => {
                    if (product?.stock > 0) {
                      // Passer les arguments directement
                      addToCartHandler(product.id, quantity);
                    }
                  }}
                  disabled={product?.stock < 1}
                >
                  <i className="fas fa-shopping-cart"></i>
                  <span className="btn-text mx-2">add to cart</span>
                </button>
                &nbsp; &nbsp; &nbsp;
                <button
                  type="button"
                  className="add-to-cart-btn btn"
                  onClick={() => addToFavoriteHandler(product)}
                >
                  <i className="fa-solid fa-heart"></i>
                  <span className="btn-text mx-0"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="product-description">
          <h2>Product Description</h2>
          <p className="para fw-3 fs-15">{product?.product_description}</p>
        </div>
      </div>
      {cartMessageStatus && <CartMessage />}
      {favoriteMessageStatus && <FavoriteMessage />}
      {/* <Footer1 /> */}
    </main>
  );
};

export default ProductSingleCategoryPages;
